/**
 * @module fetchers/html
 */

/**
 * @typedef {Node} Target
 * @typedef {module:fetchers/fetch~Context} Context
 * @typedef {module:fetchers/text~Text} Text
 * @typedef {Context|{target:Target}} TargetedContext
 * @typedef {TargetedContext|Text|{element:HTMLBodyElement}} HTML
 */
import manager from '../contracts/manager.js'
import body from '../tree/body.js'
import object from '../utils/object.js'
import text from './text.js'

/**
 * Fetches a request as an HTML and triggers the contacts on it
 * @param {TargetedContext} context
 * @returns {Promise<HTML>}
 */
export default async (
  context
) => {
  const result = await text(context)
  const { fetched, target } = result
  const { ownerDocument } = target
  const element = body(fetched, ownerDocument)

  await manager.trigger(element)

  return object(result, {
    element
  })
}
